<template>
<div>
    <!-- Error/Status Popups -->
     <div v-if="submitting" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#52b2cf" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <div class="error_popup popup-desktop" v-if="showDisqualify" style="display:block;">
        <div class="error_box error-pop-desk">
            <div class="text-block-1101" style="font-size: 16px;font-weight: bold;">We Cannot Proceed</div>
            <div class="text-block-1102" style="font-size: 14px;">
                {{ disqualifyMessage || 'Based on your responses, we cannot proceed with your application at this time.' }}
                <br /><br />
                If you believe there was an error in your submission, please click "Resubmit Form" below to update your information.
                <br /><br />
                If you prefer not to proceed, you can select "Process Refund" to request a refund.
            </div>
            <div class="button-model-yes-no new-yes-no" style="display: flex;justify-content: center;width: 100%;">
                <a href="#" class="button-107 w-button" @click.prevent="showDisqualify=false;" style="background-color: var(--light-green);color: #fff; text-align: center;">Resubmit Form</a>&nbsp;&nbsp;&nbsp;
                <a href="#" class="button-107 w-button" style="background-color: var(--light-blue);color: #fff; text-align: center;" @click.prevent="disqualifyUserAndRefund()">Process Refund</a>
            </div>
        </div>
    </div>

    <!-- Header/Navigation -->
    <section class="simple-nav">
        <div class="simplenav_wrap">
            <div class="simplenav_flex">
                <div class="nav-left-div">
                    <a href="#" class="link-block w-inline-block"><img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-545"></a>
                    <div class="nav-menu-links-div desk">

                        <div class="div-block-1129"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav-shadow"></div>
        <div class="mobile-nav-div">
            <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-mobile w-nav">
                <a href="#" class="brand home w-nav-brand"><img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-551"></a>

                <div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div>
            </div>
            <div class="div-block-1958"></div>
        </div>
    </section>

    <!-- Question Content -->
    <div v-if="gettingDetails">
        <div class="dotted-loader"></div>
        <div class="h-80"></div>
    </div>
    <section class="section-7" style="justify-content: center;display: flex; margin-top:30px" v-else>
        <div class="questions-div setsizeonphone">
            <div class="question-content">
                <div class="question-container" v-if="currentQuestion">
                    <div class="question-div-2">
                        <div class="text-block-513" v-if="currentQuestion.question_type === 'dose_optimization'">Choose Dosage Schedule: </div>
                        <div class="text-block-513" v-else v-html="currentQuestion.label"></div>
                        
                        <div class="form-subs" v-if="currentQuestion.description && (currentQuestion.question_type !== 'dose_optimization')" :class="{'consent-text' : currentQuestion.question_type === 'consent'}" v-html="currentQuestion.description"></div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'consent'">
                            <a href="#" class="link-block-30 w-inline-block acceptbutton" @click.prevent="handleAnswer('YES, I CONSENT to being treated with GLP-1 agonists. I have reviewed the risks and benefits above.')">
                                <div>
                                    <div class="text-block-545" style="color:#000">YES, I CONSENT to being treated with GLP-1 agonists. I have reviewed the risks and benefits above.</div>
                                </div>
                            </a>
                            <a href="#" class="link-block-30 w-inline-block rejectconbutton" @click.prevent="handleAnswer('NO, I DO NOT consent to being treated with a GLP-1')">
                                <div>
                                    <div class="text-block-545" style="color:#000">NO, I DO NOT consent to being treated with a GLP-1</div>
                                </div>
                            </a>
                        </div>
                        <!-- Single Option/Radio Questions -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'single_option'">
                            <form>
                                <a href="#" v-for="option in currentQuestion.options" :key="option.title" :class="{'selected': isOptionSelected(option.title)}" @click.prevent="handleAnswerSingle(option)" class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545" style="color: black;">{{option.title}}</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>
                        <!-- Updated dose_optimization template with two div-block-1977 containers -->
                        <div class="w-form" v-if="currentQuestion.question_type === 'dose_optimization'">
                            <div class="w-form">
                                <form>
                                    <!-- First row (first 3 months or all months if standard plan) -->
                                    <div class="dosage-drops-div">
                                        <div class="dose-sched-box" v-for="(month, index) in months.slice(0, 3)" :key="`month-${index}`">
                                            <div class="text-block-1241">{{ month }}</div>
                                            <select v-model="selectedDoses[index]" class="select-field-10 w-select" @change="saveProgressToStorage">
                                                <option :value="null" disabled>{{ month }}</option>
                                                <option v-for="option in getDoseOptions(index)" :key="option.value" :value="option.value">
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <!-- Second row (months 4-6) - only shown for 6-month plan -->

                                    <div class="dosage-drops-div" v-if="months.length > 3">
                                        <div class="dose-sched-box" v-for="(month, index) in months.slice(3)" :key="`month-${index+3}`">
                                            <div class="text-block-1241" v-if="index<2">{{ month }}</div>
                                            <div class="text-block-1241" v-else>Month 6-12</div>
                                            <select v-model="selectedDoses[index+3]" class="select-field-10 w-select" @change="saveProgressToStorage">
                                                <option :value="null" disabled>{{ month }}</option>
                                                <option v-for="option in getDoseOptions(index+3)" :key="option.value" :value="option.value">
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <button type="button" class="form-button w-button balugabtn" @click="handleNext" :disabled="!selectedDoses.every(dose => dose !== null && dose !== undefined)">
                                        Next ->
                                    </button>
                                </form>
                            </div>
                        </div>

                        <!-- Multiple Option/Checkbox Questions -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'multiple_option'">
                            <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="option in currentQuestion.options" :key="option"> &nbsp;&nbsp;
                                <input type="checkbox" :value="option.title" :checked="isOptionSelected(option)" @change="handleCheckboxChange($event, option.title)" class="w-checkbox-input checkbox-11">
                                <span class="checkbox-label-12 w-form-label">{{option.title}}</span>
                            </label>
                            <button v-if="canProceed" @click="handleNext" class="form-button w-button balugabtn">
                                Next ->
                            </button>
                        </div>

                        <!-- Text Input -->
                        <div class="felix-form-block w-form" v-if="['text', 'textarea'].includes(currentQuestion.question_type)">
                            <div class="condition-question mb-4">
                                <textarea v-model="currentAnswer" :placeholder="currentQuestion.placeholder || currentQuestion.sublabel || 'Enter your answer here'" class="textarea w-input" @input="handleTextInput" @keydown.enter.prevent rows="3">
                            </textarea>
                            </div>
                            <button type="button" class="form-button w-button balugabtn" @click="handleNext" :class="{ 'next-button-enabled': canProceed }" :disabled="!canProceed">
                                Next ->
                            </button>
                        </div>

                        <div class="felix-form-block w-form" v-if="['string', 'integer'].includes(currentQuestion.question_type)">
                            <div class="condition-question mb-4">
                                <input type="text" v-model="currentAnswer" :placeholder="currentQuestion.placeholder || currentQuestion.sublabel || 'Enter your answer here'" class="enroll-form-text-field weight w-input" @input="handleTextInput" @keydown.enter.prevent rows="3">
                            </div>
                            <button type="button" class="form-button w-button balugabtn" @click="handleNext" :class="{ 'next-button-enabled': canProceed }" :disabled="!canProceed">
                                Next ->
                            </button>
                        </div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type==='dose_radio_more'">
                            <form>
                                <a href="#" class="link-block-30 w-inline-block" v-for="option in currentQuestion.show_array" :key="option.sub_txt" @click.prevent="handleAnswer(option.baluga_ques)">
                                    <div class="div-block-1976">
                                        <div class="text-block-1239" v-html="option.main_txt"></div>
                                        <div class="text-block-1240" v-html="option.sub_txt"></div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-&gt;</div>
                                    </div>
                                </a>
                            </form>
                        </div>

                        <!-- File Upload -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'image_upload' || currentQuestion.question_type === 'file'">
                            <div class="image-uploader">
                                <div class="upload-box" @dragover.prevent @drop.prevent="handleDrop" :class="{ 'drag-over': isDragging }" @dragenter.prevent="isDragging = true" @dragleave.prevent="isDragging = false">

                                    <input type="file" ref="fileInput" @change="handleFileChange" accept="image/*" class="file-input">

                                    <div class="upload-content">
                                        <div v-if="uploadLoading" class="loading">Processing...</div>

                                        <div v-else-if="uploadedFile" class="preview">
                                            <img :src="previewUrl" alt="Preview" v-if="previewUrl">
                                            <p class="file-info">{{ uploadedFile.name }} ({{ formatFileSize(uploadedFile.size) }})</p>
                                            <p class="upload-info">Click or drag to upload a new image</p>
                                        </div>

                                        <div v-else class="upload-prompt">
                                            <i class="upload-icon"><img src="@/assets/images/upload-icon.svg"  style="height:25px"></i>
                                            <p>Drop image here or click to upload</p>
                                            <p class="file-size-info">Maximum file size: 5 MB</p>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="uploadError" class="error-message">
                                    {{ uploadError }}
                                    <div class="error-action">Please try uploading again</div>
                                </div>
                                <div v-if="uploading && uploadProgress > 0" class="upload-progress-container">
                                    <div class="upload-progress-bar">
                                        <div class="upload-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
                                    </div>
                                    <div class="upload-progress-text">Uploading... {{ Math.round(uploadProgress) }}%</div>
                                </div>
                                <button class="form-button w-button balugabtn" :disabled="!uploadedFile || uploadLoading || uploading" :class="{ 'error-state': uploadError }" @click="confirmUpload">
                                    {{ uploadButtonText }}
                                </button>
                            </div>
                        </div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'confirmation_buttons'">
                            <form>
                                <a href="#" v-for="option in currentQuestion.options" :key="option.title" @click.prevent="handleConfirmationAnswer(option)" 
                                class="link-block-30 w-inline-block"
                                :class="{'confirm-button': option.title === 'Confirm', 'back-button': option.title === 'Back'}">
                                    <div>
                                        <div class="text-block-545" :style="getButtonTextStyle(option.title)">{{option.title}}</div>
                                    </div>
                                    <div v-if="option.title === 'Confirm'">
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>

                        <!-- Informational -->
                        <div v-if="currentQuestion.question_type === 'informational'" class="info-message">

                            <button v-if="currentQuestion.has_next_button !== false" @click="handleNext" class="form-button w-button balugabtn">
                                Next ->
                            </button>
                        </div>
                    </div>
                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="goBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <div style="height: 340px;"></div>
</div>
</template>

<script>
import {
    getProductById
} from '@/utils/productData'
import {
    mapGetters
} from 'vuex';

const checkOptionProperties = (question, answer) => {
    if (!question.options || !answer) return {
        important: false,
        is_critical: false
    };
    // Handle multiple choice answers
    if (Array.isArray(answer)) {
        return answer.reduce((acc, selectedAnswer) => {
            const option = question.options.find(opt => opt.title === selectedAnswer);
            if (option) {
                return {
                    important: acc.important || option.important || false,
                    is_critical: acc.is_critical || option.is_critical || false
                };
            }
            return acc;
        }, {
            important: false,
            is_critical: false
        });
    }

    // Handle single choice answers
    const option = question.options?.find(opt => opt.title === answer);
    return {
        important: option?.important || false,
        is_critical: option?.is_critical || false
    };
};

export default {
    name: 'DynamicQuestionnaire',
    props: ["userState", "amountPaid", "product_id", "formType"],
    components: {},
    data() {
        return {
            currentQuestionIndex: 0,
            answers: {},
            multipleChoiceAnswers: {},
            uploadProgress: 0,
            maintanenceDose: 10,
            productPurchased: '',
            gettingDetails: true,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            currentAnswer: '',
            questions: [],
            submitting: true,
            showDisqualify: false,
            disqualifyMessage: '',
            uploadedFile: null,
            previewUrl: '',
            uploadError: '',
            uploadLoading: false,
            uploading: false,
            uploadComplete: false,
            isDragging: false,
            maxFileSizeMB: 5,
            dependencies: [],
            adjustmentType: "",
            months: [],
            drugs: {
                semaglutide: [{
                        strength: 0.25,
                        label: '0.25mg (Starting Dose)'
                    },
                    {
                        strength: 0.5,
                        label: '0.5mg'
                    },
                    {
                        strength: 1.0,
                        label: '1.0mg'
                    },
                    {
                        strength: 1.7,
                        label: '1.7mg'
                    },
                    {
                        strength: 2.4,
                        label: '2.4mg'
                    }
                ],
                tirzepatide: [{
                        strength: 2.5,
                        label: '2.5mg (Starting Dose)'
                    },
                    {
                        strength: 5.0,
                        label: '5.0mg'
                    },
                    {
                        strength: 7.5,
                        label: '7.5mg'
                    },
                    {
                        strength: 10.0,
                        label: '10.0mg'
                    },
                    {
                        strength: 12.5,
                        label: '12.5mg'
                    },
                    {
                        strength: 15.0,
                        label: '15.0mg'
                    }
                ]
            },
            selectedDrug: null,
            selectedDoses: Array(3).fill(null),
            // Add localStorage key for this specific form
            storageKey: '',
            // Add page load timestamp for crash detection
            pageLoadTimestamp: Date.now(),
        }
    },

    computed: {
        ...mapGetters(['user']),
        currentQuestion() {
            return this.questions[this.currentQuestionIndex] || null
        },
        uploadButtonText() {
            if (this.uploading) return 'Uploading...'
            if (this.uploadError) return 'Try Again'
            if (this.uploadComplete) return 'Uploaded!'
            return 'Confirm Upload'
        },

        maxFileSizeBytes() {
            return this.maxFileSizeMB * 1024 * 1024;
        },
        form_id() {
            return this.$route.params.id;
        },
        canProceed() {
            if (!this.currentQuestion) return false

            const answer = this.getCurrentAnswer()

            switch (this.currentQuestion.question_type) {
                case 'single_option':
                    return !!answer
                case 'multiple_option':
                    return Array.isArray(answer) && answer.length > 0
                case 'text':
                case 'string':
                case 'textarea':
                    return !!answer && answer.trim().length > 0
                case 'integer':
                    return !isNaN(answer) && answer !== null && answer !== ''
                case 'file':
                case 'image_upload':
                    return this.currentQuestion.is_optional || !!answer
                case 'informational':
                    return true
                case 'dose_optimization':
                    return this.selectedDoses.length === this.months.length && this.selectedDoses.every(dose => dose !== null && dose !== undefined)
                default:
                    return true
            }
        },

    },

    watch: {
        currentQuestionIndex: {
            handler() {
                this.scrolltoTop();

                // Reset upload state when changing questions
                this.resetUploadState();

                if (this.currentQuestion && this.currentQuestion.important) {
                    this.validateAnswers();
                }
                this.saveProgressToStorage();
            }
        },
        // Watch for changes in answers to automatically save progress
        answers: {
            handler() {
                this.saveProgressToStorage();
            },
            deep: true
        },
        // Watch for changes in multiple choice answers
        multipleChoiceAnswers: {
            handler() {
                this.saveProgressToStorage();
            },
            deep: true
        },
        // Watch for changes in current answer
        currentAnswer: {
            handler() {
                this.saveProgressToStorage();
            }
        },
        // Watch for changes in maintenance dose
        maintanenceDose: {
            handler() {
                this.saveProgressToStorage();
            }
        }
    },

    created() {
        // Initialize storage key based on form ID and user
        this.initializeStorageKey();
        this.getOrder();
        this.initializeQuestions();
    },

    mounted() {
        // We'll load progress in initializeQuestions after questions are loaded
    },

    // Add beforeUnload listener to save progress when user leaves the page
    beforeMount() {
        window.addEventListener('beforeunload', this.saveProgressToStorage);
    },

    beforeDestroy() {
        // Clean up event listener
        window.removeEventListener('beforeunload', this.saveProgressToStorage);
    },

    methods: {
        // Initialize the storage key for this specific form session
        createConfirmationQuestion() {
            return {
                "id": "8_confirm",
                "question": "confirm_no_weight_meds",
                "label": "Please confirm that you are not taking any weight loss medication, as you will be prescribed starter doses.",
                "description": "We will not be able to change the prescription once approved by the doctor.",
                "question_type": "confirmation_buttons",
                "options": [
                    {
                        "title": "Confirm",
                        "order": 1,
                        "important": false,
                        "is_critical": false
                    },
                    {
                        "title": "Back",
                        "order": 2,
                        "important": false,
                        "is_critical": false,
                        "is_back_button": true
                    }
                ],
                "important": false,
                "is_critical": false,
                "isInserted": true // Mark as dynamically inserted
            };
        },
        initializeStorageKey() {
            // Create a unique key based on form ID and user ID (if available)
            const userId = this.user?.id || 'anonymous';
            const formId = this.$route.params.id || 'default';
            this.storageKey = `medIntegration_progress_${userId}_${formId}`;
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes'
            const k = 1024
            const sizes = ['Bytes', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
        },

        createPreviewUrl(file) {
            // Clean up previous preview URL to prevent memory leaks
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl)
            }
            this.previewUrl = URL.createObjectURL(file)
        },

        async processUploadFile(file) {
            // Reset upload state
            this.uploadError = ''
            this.uploadLoading = true
            this.uploadedFile = null
            this.previewUrl = ''
            this.uploadComplete = false
            this.uploading = false

            try {
                if (!file) {
                    throw new Error('Please select a file')
                }

                if (!file.type.startsWith('image/')) {
                    throw new Error('Please upload an image file')
                }

                // Check file size (5 MB limit)
                if (file.size > this.maxFileSizeBytes) {
                    throw new Error(`File size exceeds ${this.maxFileSizeMB} MB limit. Please choose a smaller file.`)
                }

                // Set the file and create preview
                this.uploadedFile = file
                this.createPreviewUrl(file)

                console.log('✅ File processed successfully:', file.name)

            } catch (err) {
                this.uploadError = err.message
                console.error('❌ File processing error:', err)
            } finally {
                this.uploadLoading = false
            }
        },

        handleFileChange(event) {
            const file = event.target.files[0]
            if (file) {
                this.processUploadFile(file)
            }
        },

        handleDrop(event) {
            this.isDragging = false
            const file = event.dataTransfer.files[0]
            if (file) {
                this.processUploadFile(file)
            }
        },

        generateUniqueFilename(originalName) {
            const timestamp = new Date().getTime()
            const extension = originalName.split('.').pop()
            const nameWithoutExt = originalName.split('.').slice(0, -1).join('.')
            return `${this.form_id}_${this.currentQuestion.question}_${timestamp}_${nameWithoutExt}.${extension}`
        },

        async getSignedUrl(filename, contentType) {
            try {
                const response = await fetch(`${this.baseUrl}/api/get-signed-url`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        filename,
                        content_type: contentType
                    })
                })

                if (!response.ok) {
                    throw new Error('Failed to get signed URL')
                }

                return await response.json()
            } catch (error) {
                throw new Error('Error getting signed URL: ' + error.message)
            }
        },

        async uploadToS3(signedUrl, file) {
            try {
                // Use XMLHttpRequest for real upload progress tracking instead of fetch
                return new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest()

                    // Track upload progress - this enables the progress bar
                    xhr.upload.addEventListener('progress', (event) => {
                        if (event.lengthComputable) {
                            // Calculate and update progress percentage
                            this.uploadProgress = Math.round((event.loaded / event.total) * 100)
                            console.log(`Upload progress: ${this.uploadProgress}%`)
                        }
                    })

                    // Handle successful completion
                    xhr.addEventListener('load', () => {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            this.uploadProgress = 100 // Ensure we show 100% completion
                            console.log('Upload completed successfully')
                            resolve()
                        } else {
                            reject(new Error('Failed to upload file to S3'))
                        }
                    })

                    // Handle network errors
                    xhr.addEventListener('error', () => {
                        reject(new Error('Network error during upload. Please check your internet connection.'))
                    })

                    // Handle upload cancellation
                    xhr.addEventListener('abort', () => {
                        reject(new Error('Upload was cancelled'))
                    })

                    // Configure and send the request
                    xhr.open('PUT', signedUrl)
                    xhr.setRequestHeader('Content-Type', file.type)
                    xhr.send(file)
                })

            } catch (error) {
                throw new Error('Error uploading to S3: ' + error.message)
            }
        },

        async confirmUpload() {
            if (!this.uploadedFile || this.uploading) return

            this.uploading = true
            this.uploadError = ''
            this.uploadComplete = false
            this.uploadProgress = 0 // Reset progress at start

            try {
                // Generate unique filename
                const filename = this.generateUniqueFilename(this.uploadedFile.name)
                console.log('🔄 Generated filename:', filename)

                // Get signed URL
                console.log('🔄 Requesting signed URL for:', filename)
                const urlData = await this.getSignedUrl(filename, this.uploadedFile.type)
                if (!urlData?.url) {
                    throw new Error('Failed to get upload URL')
                }
                console.log('✅ Received signed URL')

                // Upload file to S3 with progress tracking
                console.log('🔄 Starting S3 upload with file size:', this.uploadedFile.size)
                await this.uploadToS3(urlData.url, this.uploadedFile)
                console.log('✅ S3 upload completed successfully')

                await this.$nextTick()

                // Set upload complete
                this.uploadComplete = true

                // **DIRECTLY UPDATE ANSWERS AND MOVE TO NEXT QUESTION**
                console.log('📝 Setting answer for current question:', this.currentQuestion.id)
                this.$set(this.answers, this.currentQuestion.id, filename)

                console.log('✅ Upload successful, moving to next question')

                // Add a small delay to ensure UI updates, then move to next question
                setTimeout(() => {
                    this.moveToNextQuestion()
                    this.resetUploadState() // Clean up upload state
                }, 500)

            } catch (err) {
                console.error('❌ Upload error:', err)

                // Log upload attempt for debugging
                try {
                    await this.logUploadAttempt({
                        success: false,
                        errorMessage: err.message,
                        fileSize: this.uploadedFile?.size,
                        filename: this.uploadedFile?.name
                    })
                } catch (e) {
                    console.log('Failed to log upload attempt:', e)
                }

                // Set user-friendly error messages
                if (err.message.includes('Failed to fetch') || err.message.includes('Network')) {
                    this.uploadError = 'Upload failed due to connection issues. Please check your internet connection and try again.'
                } else if (err.message.includes('signed URL')) {
                    this.uploadError = 'Error preparing upload. Please try again.'
                } else if (err.message.includes('S3')) {
                    this.uploadError = 'Error uploading file. Please try again.'
                } else {
                    this.uploadError = 'The upload was unsuccessful. Please try again.'
                }
                this.uploadComplete = false
            } finally {
                this.uploading = false
                this.uploadProgress = 0 // Reset progress when done
            }
        },

        async logUploadAttempt({
            success,
            errorMessage = '',
            fileSize = 0,
            filename = ''
        }) {
            try {
                await this.$axios.post(`${this.baseUrl}/api/log-upload-attempt`, {
                    success,
                    error: errorMessage,
                    userAgent: navigator.userAgent,
                    fileSize,
                    filename,
                    imageType: this.currentQuestion?.question || 'unknown',
                    idOfForm: this.form_id,
                    timestamp: new Date().toISOString()
                })
            } catch (err) {
                console.warn('Failed to log upload attempt:', err)
            }
        },

        resetUploadState() {
            // Clean up upload state when moving to next question
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl)
            }
            this.uploadedFile = null
            this.previewUrl = ''
            this.uploadComplete = false
            this.uploadError = ''
            this.uploadLoading = false
            this.uploading = false
            this.isDragging = false
            this.uploadProgress = 0 // Reset progress when cleaning up state
        },

        // Enhanced save with crash recovery metadata
        saveProgressToStorage() {
            try {
                const progressData = {
                    currentQuestionIndex: this.currentQuestionIndex,
                    answers: this.answers,
                    multipleChoiceAnswers: this.multipleChoiceAnswers,
                    currentAnswer: this.currentAnswer,
                    maintanenceDose: this.maintanenceDose,
                    selectedDoses: this.selectedDoses,
                    selectedDrug: this.selectedDrug,
                    productPurchased: this.productPurchased,
                    months: this.months,
                    // Enhanced crash recovery metadata
                    savedAt: new Date().toISOString(),
                    sessionId: this.getSessionId(),
                    url: window.location.href,
                    userAgent: navigator.userAgent,
                    crashRecovery: {
                        lastActiveTimestamp: Date.now(),
                        pageLoadTimestamp: this.pageLoadTimestamp,
                        totalAnswersCount: Object.keys(this.answers).length,
                        isFormComplete: this.currentQuestionIndex >= this.questions.length - 1
                    },
                    version: '1.0'
                };

                localStorage.setItem(this.storageKey, JSON.stringify(progressData));

                // Also save a backup with timestamp for crash recovery
                const backupKey = `${this.storageKey}_backup_${Date.now()}`;
                localStorage.setItem(backupKey, JSON.stringify(progressData));

                // Clean up old backups (keep only last 3)
                this.cleanupOldBackups();

                console.log('Progress saved to localStorage', {
                    questionIndex: this.currentQuestionIndex,
                    answersCount: Object.keys(this.answers).length,
                    sessionId: progressData.sessionId
                });
            } catch (error) {
                console.error('Error saving progress to localStorage:', error);
                // Try to save minimal data if full save fails
                this.saveMinimalProgress();
            }
        },

        // Enhanced loading with crash recovery
        async loadProgressFromStorage() {
            try {
                let savedData = localStorage.getItem(this.storageKey);

                // If main save is corrupted, try to recover from backups
                if (!savedData || !this.isValidProgressData(JSON.parse(savedData))) {
                    console.log('Main save corrupted, attempting backup recovery...');
                    savedData = this.recoverFromBackups();
                }

                if (!savedData) {
                    console.log('No valid saved progress found');
                    return;
                }

                const progressData = JSON.parse(savedData);

                // Validate the saved data structure
                if (!this.isValidProgressData(progressData)) {
                    console.warn('Invalid progress data found, starting fresh');
                    this.clearProgressFromStorage();
                    return;
                }

                // Enhanced crash detection
                if (this.detectPotentialCrash(progressData)) {
                    console.log('Potential crash detected, offering recovery options');
                    this.showCrashRecoveryDialog(progressData);
                }

                // Check if the saved data is too old (optional - you can set a limit like 24 hours)
                const savedAt = new Date(progressData.savedAt);
                const now = new Date();
                const hoursSinceLastSave = (now - savedAt) / (1000 * 60 * 60);

                // If data is older than 7 days, start fresh (optional)
                if (hoursSinceLastSave > 168) {
                    console.log('Saved progress is too old, starting fresh');
                    this.clearProgressFromStorage();
                    return;
                }

                // Restore the progress data
                await this.restoreProgressData(progressData);

                console.log('Progress loaded from localStorage', {
                    questionIndex: this.currentQuestionIndex,
                    answersCount: Object.keys(this.answers).length,
                    savedAt: progressData.savedAt,
                    sessionRecovered: progressData.sessionId !== this.getSessionId()
                });

                // Show recovery notification if this was from a different session
                if (progressData.sessionId !== this.getSessionId()) {
                    this.showRecoveryNotification(progressData);
                }

            } catch (error) {
                console.error('Error loading progress from localStorage:', error);
                // If there's an error loading saved data, try backup recovery
                const backupData = this.recoverFromBackups();
                if (backupData) {
                    console.log('Recovered from backup after main recovery failed');
                    this.loadProgressFromStorage();
                } else {
                    this.clearProgressFromStorage();
                }
            }
        },

        // Validate the structure of saved progress data
        isValidProgressData(data) {
            // Check if required properties exist and have correct types
            return data &&
                typeof data.currentQuestionIndex === 'number' &&
                typeof data.answers === 'object' &&
                typeof data.multipleChoiceAnswers === 'object' &&
                data.selectedDoses && Array.isArray(data.selectedDoses) &&
                data.savedAt &&
                data.version;
        },

        // Restore progress data to component state
        async restoreProgressData(progressData) {
            // Restore basic progress data
            this.answers = progressData.answers || {};
            this.multipleChoiceAnswers = progressData.multipleChoiceAnswers || {};
            this.maintanenceDose = progressData.maintanenceDose || 10;
            this.selectedDoses = progressData.selectedDoses || Array(3).fill(null);
            this.selectedDrug = progressData.selectedDrug || null;

            // Only restore product/months data if it matches current session
            if (progressData.productPurchased === this.productPurchased) {
                this.months = progressData.months || this.months;
            }

            // Restore question index AFTER all other data is restored
            const savedQuestionIndex = Math.min(progressData.currentQuestionIndex || 0, this.questions.length - 1);

            // Validate that the saved question index makes sense
            if (savedQuestionIndex >= 0 && savedQuestionIndex < this.questions.length) {
                this.currentQuestionIndex = savedQuestionIndex;
            } else {
                this.currentQuestionIndex = 0;
            }

            // Set currentAnswer based on the current question after index is set
            await this.$nextTick(); // Wait for reactivity to update currentQuestion

            if (this.currentQuestion && this.answers[this.currentQuestion.id]) {
                this.currentAnswer = this.answers[this.currentQuestion.id];
            } else {
                this.currentAnswer = progressData.currentAnswer || '';
            }

            // Log restoration details
            console.log('Progress restored:', {
                questionIndex: this.currentQuestionIndex,
                currentQuestionId: this.currentQuestion?.id,
                answersCount: Object.keys(this.answers).length,
                hasCurrentAnswer: !!this.currentAnswer
            });
        },

        // Clear saved progress from localStorage
        clearProgressFromStorage() {
            try {
                const keysToRemove = [];
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);

                    if (key && this.isFormRelatedKey(key)) {
                        try {
                            keysToRemove.push(key);
                        } catch (e) {
                            // If we can't parse the data, it's probably corrupted - remove it
                            keysToRemove.push(key);
                        }
                    }
                }

                keysToRemove.forEach(key => {
                    localStorage.removeItem(key);
                });

                sessionStorage.removeItem('formSessionId');
            } catch (error) {
                console.log(error)
            }
        },

        isFormRelatedKey(key, patterns = null) {
            const defaultPatterns = [
                'bareMeds',
                'medIntegration_progress_',
                'formLoader_state_',
                'refillFormMdi_progress_',
                '_backup_',
                '_minimal',
                'userState'
            ];

            const patternsToUse = patterns || defaultPatterns;

            return patternsToUse.some(pattern => key.includes(pattern)) ||
                key.match(/^(bareMeds|medIntegration|formLoader|refillFormMdi).*_(progress|state|backup|minimal)/);
        },

        // Add method to manually clear progress (could be called from UI)
        resetProgress() {
            // Clear localStorage
            this.clearProgressFromStorage();

            // Reset component state
            this.currentQuestionIndex = 0;
            this.answers = {};
            this.multipleChoiceAnswers = {};
            this.currentAnswer = '';
            this.maintanenceDose = 10;
            this.selectedDoses = Array(3).fill(null);
            this.selectedDrug = null;

            console.log('Progress reset');
        },

        getMeaintanceDose() {
            return [{
                    value: 2.5,
                    label: '2.5mg '
                },
                {
                    value: 5,
                    label: '5.0mg'
                },
                {
                    value: 7.5,
                    label: '7.5mg'
                },
                {
                    value: 10,
                    label: '10.0mg'
                },
                {
                    value: 12.5,
                    label: '12.5mg'
                },
                {
                    value: 15,
                    label: '15.0mg'
                }
            ];
        },
        goBack() {
            // If we're at the first question, there's nowhere to go back to
            if (this.currentQuestionIndex <= 0) {
                return;
            }

            // Clear current question's answer
            if (this.currentQuestion) {
                // Handle multiple choice answers
                if (this.currentQuestion.question_type === 'multiple_option') {
                    this.$delete(this.multipleChoiceAnswers, this.currentQuestion.id);
                }

                // Clear the current answer in both places it might be stored
                this.$delete(this.answers, this.currentQuestion.id);
                this.currentAnswer = '';

                // Clear selected doses if we're going back from dose optimization
                if (this.currentQuestion.question_type === 'dose_optimization') {
                    this.selectedDoses = Array(3).fill(null);
                }
            }

            // Find the previous question
            let previousIndex = this.currentQuestionIndex - 1;

            // Skip back past any hidden questions
            while (previousIndex >= 0 && !this.shouldShowQuestion(this.questions[previousIndex])) {
                previousIndex--;
            }

            // If we're going back from a follow-up question, go back to the parent question
            const currentQuestion = this.questions[this.currentQuestionIndex];
            if (currentQuestion.isFollowUp) {
                // Find the parent question's index
                const parentIndex = this.questions.findIndex(q => q.id === currentQuestion.parentId);
                if (parentIndex !== -1) {
                    previousIndex = parentIndex;
                }

                // Remove all follow-up questions related to this parent
                this.questions = this.questions.filter(q => !q.isFollowUp || q.parentId !== currentQuestion.parentId);
            }

            // Update the current index
            if (previousIndex >= 0) {
                this.currentQuestionIndex = previousIndex;
            }

            // Save progress after going back - this ensures localStorage reflects the current state
            this.saveProgressToStorage();
        },
        async getOrder() {
            const product = getProductById(this.product_id)[0];
            this.months = ["Month 1", "Month 2", "Month 3"];
            this.selectedDoses = Array(3).fill(null);
            this.productPurchased = product.name;
            // Don't set gettingDetails to false here - let initializeQuestions handle it
            window.scrollTo(0, 0);
        },
        async initializeQuestions() {
            try {
                
                const response = await fetch('https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/questions/new_question_mdi.json');

                if (!response.ok) {
                    this.submitting=false;
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();

                // Extract the questions and dependencies safely
                let questionsArray = data.questions || [];

                // Filter out pregnancy question if user is male
                if (this.user?.gender !== 'Female') {
                    questionsArray = questionsArray.filter(question => question.id !== '0');
                }

                this.questions = questionsArray;
                this.dependencies = data.dependency || [];
                // IMPORTANT: Load progress AFTER questions are loaded and BEFORE gettingDetails is set to false
                if (this.questions.length > 0) {
                    await this.loadProgressFromStorage();
                }

                // Only set gettingDetails to false after everything is loaded
                this.gettingDetails = false;
                this.submitting=false;
            } catch (error) {
                console.error('Error fetching questions:', error);
                // Even if there's an error, stop the loading state
                this.gettingDetails = false;
                this.submitting=false;
            }
        },

        getDoseOptions(monthIndex) {
            try {
                if (!this.selectedDrug || !this.drugs[this.selectedDrug]) {
                    return [];
                }
                const availableDoses = this.drugs[this.selectedDrug];

                // For first month, check if this is a transition case
                if (monthIndex === 0) {
                    const medQuestion = this.questions.find(q => q.question === 'current_weight_meds');
                    const lastDoseQuestion = this.questions.find(q => q.id === '8_3');
                    const currentMed = this.answers[medQuestion?.id]?.toLowerCase();
                    const lastDoseTime = this.answers[lastDoseQuestion?.id];
                    const preferenceQuestion = this.questions.find(q => q.id === '10_1');
                    const preference = this.answers[preferenceQuestion?.id];

                    if (currentMed && lastDoseTime) {
                        const currentDrugType = currentMed.includes('tirze') || currentMed.includes('mounjaro') ?
                            'tirzepatide' : 'semaglutide';

                        // Only apply transition logic if switching medications
                        if (currentDrugType !== this.selectedDrug) {
                            // If switching from Tirzepatide to Semaglutide, always return 0.25mg only
                            if (currentDrugType === 'tirzepatide' && this.selectedDrug === 'semaglutide') {
                                const startingDose = availableDoses.find(d => Math.abs(d.strength - 0.25) < 0.0001);
                                if (startingDose) {
                                    return [{
                                        label: startingDose.label || `${startingDose.strength}mg`,
                                        value: startingDose.strength
                                    }];
                                }
                            } else {
                                // For Semaglutide to Tirzepatide transitions, use existing logic
                                const currentDoseQuestion = this.questions.find(q => q.id === '8_1' || q.id === '8_2');
                                const currentDoseMatch = this.answers[currentDoseQuestion?.id]?.match(/(\d+\.?\d*)mg/);

                                if (currentDoseMatch) {
                                    const currentDose = parseFloat(currentDoseMatch[1]);
                                    const targetDose = this.getTransitionDose(currentDrugType, currentDose, lastDoseTime);

                                    const targetDoseObj = availableDoses.find(d =>
                                        Math.abs(d.strength - targetDose) < 0.0001
                                    );

                                    if (targetDoseObj) {
                                        return [{
                                            label: targetDoseObj.label || `${targetDoseObj.strength}mg`,
                                            value: targetDoseObj.strength
                                        }];
                                    }
                                }
                            }
                        } else {
                            // If on the same medication type, apply the preference logic with one-step limitation
                            const currentDoseQuestion = this.questions.find(q => q.id === '8_1' || q.id === '8_2');
                            const currentDoseMatch = this.answers[currentDoseQuestion?.id]?.match(/(\d+\.?\d*)mg/);

                            if (currentDoseMatch) {
                                const currentDose = parseFloat(currentDoseMatch[1]);
                                const currentDoseIndex = availableDoses.findIndex(dose =>
                                    Math.abs(dose.strength - currentDose) < 0.0001);

                                if (currentDoseIndex !== -1) {
                                    // Determine available options based on preference
                                    if (preference === 'same') {
                                        // For 'same' preference, only show current dose
                                        const sameOption = availableDoses[currentDoseIndex];
                                        return [{
                                            label: sameOption.label || `${sameOption.strength}mg`,
                                            value: sameOption.strength
                                        }];
                                    } else if (preference === 'increase') {
                                        // For 'increase', show current and one step up
                                        const options = [availableDoses[currentDoseIndex]];

                                        // Add next dose up if available
                                        if (currentDoseIndex < availableDoses.length - 1) {
                                            options.push(availableDoses[currentDoseIndex + 1]);
                                        }

                                        return options.map(drug => ({
                                            label: drug.label || `${drug.strength}mg`,
                                            value: drug.strength
                                        }));
                                    } else if (preference === 'decrease') {
                                        // For 'decrease', show current and one step down
                                        const options = [availableDoses[currentDoseIndex]];

                                        // Add next dose down if available
                                        if (currentDoseIndex > 0) {
                                            options.push(availableDoses[currentDoseIndex - 1]);
                                        }

                                        return options.map(drug => ({
                                            label: drug.label || `${drug.strength}mg`,
                                            value: drug.strength
                                        }));
                                    }
                                }
                            }
                        }
                    }

                    // Default to all options if not a transition case and no preference
                    return availableDoses.map(drug => ({
                        label: drug.label || `${drug.strength}mg`,
                        value: drug.strength
                    }));
                }

                // For subsequent months, show adjacent options based on the previous month
                const prevDose = this.selectedDoses[monthIndex - 1];
                if (prevDose === null) return [];

                const currentIndex = availableDoses.findIndex(dose =>
                    Math.abs(dose.strength - prevDose) < 0.0001
                );

                if (currentIndex === -1) return [];

                const options = [];

                // One step down if available
                if (currentIndex > 0) options.push(availableDoses[currentIndex - 1]);

                // Current dose
                options.push(availableDoses[currentIndex]);

                // One step up if available
                if (currentIndex < availableDoses.length - 1) options.push(availableDoses[currentIndex + 1]);

                return options.map(drug => ({
                    label: drug.label || `${drug.strength}mg`,
                    value: drug.strength
                }));
            } catch (error) {
                console.error('Error getting dose options:', error);
                return [];
            }
        },

        getTransitionDose(fromDrugType, fromDose, lastDoseTime) {
            const withinTwoWeeksMap = {
                'tirzepatide': {
                    2.5: 0.25, // Always start at lowest dose
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5, // S1 -> T1
                    0.5: 2.5, // S2 -> T1
                    1.0: 5.0, // S3 -> T2
                    1.7: 7.5, // S4 -> T3
                    2.0: 7.5, // S5 -> T3
                    2.4: 10.0, // S5 -> T3
                    2.5: 10.0 // S6 -> T4
                }
            };

            const afterTwoWeeksMap = {
                'tirzepatide': {
                    2.5: 0.25, // Always start at lowest dose
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5, // S1 -> T1
                    0.5: 2.5, // S2 -> T1
                    1.0: 5.0, // S3 -> T2
                    1.7: 5.0, // S4 -> T2
                    2.0: 7.5, // S5 -> T3
                    2.4: 7.5, // S5 -> T3
                    2.5: 7.5 // S6 -> T3
                }
            };

            const moreThanMonthMap = {
                'tirzepatide': {
                    2.5: 0.25, // Always start at lowest dose (S1)
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5, // Always start at lowest dose (T1)
                    0.5: 2.5,
                    1.0: 2.5,
                    1.7: 2.5,
                    2.0: 2.5,
                    2.4: 2.5,
                    2.5: 2.5
                }
            };
            let transitionMap;
            if (lastDoseTime === 'More than a month ago') {
                transitionMap = moreThanMonthMap;
            } else if (lastDoseTime === 'Within last 2 weeks') {
                transitionMap = withinTwoWeeksMap;
            } else {
                transitionMap = afterTwoWeeksMap;
            }
            const targetDose = transitionMap[fromDrugType][fromDose] ||
                (this.selectedDrug === 'tirzepatide' ? 2.5 : 0.25); // Default to starting dose

            return targetDose;
        },

        initializeDoses() {
            // Find current medication
            const medQuestion = this.questions.find(q => q.question === 'current_weight_meds');
            if (!medQuestion) {
                return;
            }
            const currentMed = this.answers[medQuestion.id]?.toLowerCase();
            if (!currentMed) {
                this.selectedDrug = null;
                this.selectedDoses = [null, null, null];
                return;
            }
            // Set selected drug based on product bought
            this.selectedDrug = this.productPurchased.toLowerCase().includes('sema') ? 'semaglutide' : 'tirzepatide';
            // Get current medication dose
            const isDoseTirzepatide = currentMed.includes('tirze') || currentMed.includes('mounjaro');
            const doseQuestionId = isDoseTirzepatide ? '8_2' : '8_1';
            const currentDoseQuestion = this.questions.find(q => q.id === doseQuestionId);
            if (!currentDoseQuestion || !this.answers[currentDoseQuestion.id]) {
                return;
            }
            // Parse dose value
            const doseAnswer = this.answers[currentDoseQuestion.id];
            const doseMatch = doseAnswer.match(/(\d+\.?\d*)/);
            if (!doseMatch) {
                return;
            }
            const currentDose = parseFloat(doseMatch[1]);
            const currentDrugType = currentMed.includes('tirze') || currentMed.includes('mounjaro') ?
                'tirzepatide' : 'semaglutide';

            // Get last dose timing and preference
            const lastDoseDateQuestion = this.questions.find(q => q.id === '8_3');
            const lastDoseDate = this.answers[lastDoseDateQuestion?.id];
            const preferenceQuestion = this.questions.find(q => q.id === '10_1');
            const preference = this.answers[preferenceQuestion?.id];
            if (!lastDoseDate || !preference) {
                return;
            }
            // Handle same drug vs transition
            if (currentDrugType === this.selectedDrug) {
                this.handleSameDrugDoses(currentDose, preference);
            } else {
                const targetDose = this.getTransitionDose(currentDrugType, currentDose, lastDoseDate);
                this.setDoseProgression(targetDose, preference);
            }
        },

        handleSameDrugDoses(currentDose, preference) {
            const availableDoses = this.drugs[this.selectedDrug];
            const currentDoseIndex = availableDoses.findIndex(dose =>
                Math.abs(dose.strength - currentDose) < 0.0001
            );

            if (currentDoseIndex === -1) return;

            // Create arrays of appropriate length based on months
            const monthCount = this.months.length;

            switch (preference) {
                case 'increase': {
                    // Start with current index + 1, then increase each month up to max
                    const doses = [];
                    for (let i = 0; i < monthCount; i++) {
                        const targetIndex = Math.min(currentDoseIndex + 1 + i, availableDoses.length - 1);
                        doses.push(availableDoses[targetIndex].strength);
                    }
                    this.selectedDoses = doses;
                    break;
                }
                case 'same':
                    // All months get the same dose
                    this.selectedDoses = Array(monthCount).fill(availableDoses[currentDoseIndex].strength);
                    break;
                case 'decrease': {
                    // Start with current index - 1, maintain that dose
                    const decreaseIndex = Math.max(currentDoseIndex - 1, 0);
                    this.selectedDoses = Array(monthCount).fill(availableDoses[decreaseIndex].strength);
                    break;
                }
                default:
                    this.selectedDoses = Array(monthCount).fill(null);
            }
        },

        setDoseProgression(initialDose, preference) {
            const availableDoses = this.drugs[this.selectedDrug];
            const startIndex = availableDoses.findIndex(dose =>
                Math.abs(dose.strength - initialDose) < 0.0001
            );

            if (startIndex === -1) {
                this.selectedDoses = Array(this.months.length).fill(null);
                return;
            }

            // Get the number of months we need to plan for
            const monthCount = this.months.length;

            switch (preference) {
                case 'increase': {
                    // Create a progressive dose schedule
                    const doses = [];
                    for (let i = 0; i < monthCount; i++) {
                        const targetIndex = Math.min(startIndex + i, availableDoses.length - 1);
                        doses.push(availableDoses[targetIndex].strength);
                    }
                    this.selectedDoses = doses;
                    break;
                }
                case 'same':
                    // All months get the same dose
                    this.selectedDoses = Array(monthCount).fill(availableDoses[startIndex].strength);
                    break;
                case 'decrease': {
                    // Start with one step lower, maintain that dose
                    const decreaseIndex = Math.max(startIndex - 1, 0);
                    this.selectedDoses = Array(monthCount).fill(availableDoses[decreaseIndex].strength);
                    break;
                }
                default:
                    this.selectedDoses = Array(monthCount).fill(null);
            }
        },

        getCurrentAnswer() {
            if (!this.currentQuestion) return null
            return this.currentQuestion.question_type === 'multiple_option' ?
                this.multipleChoiceAnswers[this.currentQuestion.id] :
                this.currentAnswer || this.answers[this.currentQuestion.id]
        },

        isOptionSelected(option) {
            const answer = this.getCurrentAnswer()
            return Array.isArray(answer) ? answer.includes(option) : answer === option
        },

        handleCheckboxChange(event, option) {
            const questionId = this.currentQuestion.id
            let answers = [...(this.multipleChoiceAnswers[questionId] || [])]

            if (event.target.checked) {
                if (option.toLowerCase().includes('none')) {
                    answers = [option]
                } else {
                    answers = answers.filter(a => !a.toLowerCase().includes('none'))
                    answers.push(option)
                }
            } else {
                answers = answers.filter(a => a !== option)
            }

            this.$set(this.multipleChoiceAnswers, questionId, answers)
            this.$set(this.answers, questionId, answers)

            // Progress will be saved automatically through the watcher
        },
        handleAnswerSingle(option) {
            // Handle the back button for the confirmation question
            if (option.is_back_button && this.currentQuestion.id === '8_confirm') {
                // Clear the confirmation answer
                this.$delete(this.answers, '8_confirm');
                // Clear the original question 8 answer to allow re-selection
                this.$delete(this.answers, '8');
                this.currentAnswer = '';
                // Go back to question 8
                const question8Index = this.questions.findIndex(q => q.id === '8');
                if (question8Index !== -1) {
                    this.currentQuestionIndex = question8Index;
                }
                this.saveProgressToStorage();
            } else if (option.is_back_button) {
                // Handle other back buttons normally
                this.goBack();
            } else {
                // Handle normal answers
                this.handleAnswer(option.title);
            }
        },
        handleAnswer(answer) {
            if (!this.currentQuestion) return
            this.$set(this.answers, this.currentQuestion.id, answer)
            this.currentAnswer = answer
            if (this.currentQuestion.question === 'next_dose_preference') {
                console.log("this is the current question ")
                this.initializeDoses();
            }
            this.moveToNextQuestion()
            // Progress will be saved automatically through the watcher
        },

        handleImageUploaded(data) {
            this.$set(this.answers, this.currentQuestion.id, data.filename)
            this.moveToNextQuestion()
            // Progress will be saved automatically through the watcher
        },

        handleNext() {
            console.log(this.currentQuestion.question_type)
            console.log("value of can proceed ", this.canProceed)
            if (!this.canProceed) return
            const answer = this.getCurrentAnswer()
            this.$set(this.answers, this.currentQuestion.id, answer)
            this.moveToNextQuestion()
            // Progress will be saved automatically through the watcher
        },

        handleTextInput(event) {
            this.currentAnswer = event.target.value
            // Progress will be saved automatically through the watcher
        },

        handleFileUpload(event) {
            const file = event.target.files[0]
            if (!file) return
            this.uploadedFile = file.name
            if (this.isImageFile(file.name)) {
                const reader = new FileReader()
                reader.onload = e => {
                    this.currentAnswer = e.target.result
                }
                reader.readAsDataURL(file)
            } else {
                this.currentAnswer = file
            }
            // Progress will be saved automatically through the watcher
        },

        isImageFile(name) {
            return typeof name === 'string' && /\.(jpg|jpeg|png|gif)$/i.test(name)
        },

        getFileName(file) {
            return file instanceof File ? file.name : 'File selected'
        },

        disqualifyUserAndRefund() {
            this.$emit('disqualify-user')
        },

        findNextQuestion() {
            if (!this.currentQuestion) return null
            const currentId = this.currentQuestion.id

            // Handle multiple choice questions with follow-ups
            if (this.currentQuestion.question_type === 'multiple_option' &&
                !this.currentQuestion.isFollowUp &&
                this.currentQuestion.followup_questions) {

                const selectedAnswers = this.multipleChoiceAnswers[currentId] || []
                if (selectedAnswers.length === 1 && selectedAnswers[0].toLowerCase().includes('none')) {
                    return this.findNextMainQuestion()
                }

                let insertedFollowUps = false
                const currentIndex = this.questions.findIndex(q => q.id === currentId)
                this.questions = this.questions.filter(q => !q.isFollowUp || q.parentId !== currentId)

                const allFollowUps = []
                selectedAnswers.forEach((answer, index) => {
                    const followUp = this.currentQuestion.followup_questions[answer]
                    if (followUp && !this.answers[followUp.id]) {
                        allFollowUps.push({
                            ...followUp,
                            parentId: currentId,
                            parentAnswer: answer,
                            isFollowUp: true,
                            order: index
                        })
                        insertedFollowUps = true
                    }
                })

                if (insertedFollowUps) {
                    this.questions.splice(currentIndex + 1, 0, ...allFollowUps)
                    return currentIndex + 1
                }
            }

            if (this.currentQuestion.isFollowUp) {
                const currentIndex = this.currentQuestionIndex
                const nextQuestion = this.questions[currentIndex + 1]
                if (nextQuestion?.isFollowUp && nextQuestion.parentId === this.currentQuestion.parentId) {
                    return currentIndex + 1
                }
            }

            return this.findNextMainQuestion()
        },

        findNextMainQuestion() {
            for (let i = this.currentQuestionIndex + 1; i < this.questions.length; i++) {
                const question = this.questions[i]
                if (!question.isFollowUp && this.shouldShowQuestion(question)) {
                    return i
                }
            }
            return null
        },

        moveToNextQuestion() {
            if (this.currentQuestion) {
                const answer = this.getCurrentAnswer()
                this.$set(this.answers, this.currentQuestion.id, answer)
            }

            const nextIndex = this.findNextQuestion()
            if (nextIndex !== null) {
                this.currentQuestionIndex = nextIndex
                this.currentAnswer = ''
            } else {
                const allAnswered = this.verifyAllFollowupsComplete()
                if (allAnswered) {
                    this.submitting = true
                    this.handleFinalSubmit()
                }
            }
            // Progress will be saved automatically through the watcher
        },

        async handleFinalSubmit() {
            this.submitting = true;
            try {
                if (this.productPurchased === 'Tirzepatide') {
                    // Check if doses are missing or not fully specified
                    const hasEmptyDoses = this.selectedDoses.some(dose => dose === null || dose === undefined);
                    if (hasEmptyDoses) {
                        // Set default progression for Tirzepatide: 2.5, 5, 7.5, 10, 10, 10
                        this.selectedDoses = [2.5, 5, 7.5];
                        // Ensure the array is the right length based on months
                        // If maintenance dose is not set, default to 10mg
                        if (!this.maintanenceDose) {
                            this.maintanenceDose = 10;
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }

            // Determine form name and endpoint based on form type
            const formName = this.formType === 'bareMeds' ? 'bareMeds' : 'mdIntegration';
            const endpoint = this.formType === 'bareMeds' 
                ? `https://webhooks.ohmymeds.com/api/submit-bare-form`
                : `https://webhooks.ohmymeds.com/api/submit-md-form`;

            const submissionData = {
                ...this.formatAnswers(),
                form_id: this.$route.params.id,
                userInfo: this.user,
                paymentTerms: this.amountPaid,
                maintanenceDose: this.maintanenceDose,
                productPurchased: this.productPurchased,
                isRefil: false,
                frmName: formName
            };

            try {
                await this.$axios.post(endpoint, submissionData);

                // Clear saved progress after successful submission
                await this.clearProgressFromStorage();
                this.submitting = false;
                try{
                    if(this.formType === 'bareMeds'){
                        const restrictedStates = ["AR", "IN", "IA", "KS", "KY", "MT", "OK", "SC", "SD", "TX", "WV", "IL", "NJ", "OR", "VA", "WA"];
                        if (restrictedStates.includes(this.userState)) {
                            this.$router.push({
                                name: 'uploadVideo',
                                params: {
                                    id: this.$route.params.id
                                }
                            });
                        } else {
                            this.$router.push('/home');
                        }
                    } else {
                        this.$router.push('/home');
                    }
                }catch(error){
                    console.log(error);
                    this.$router.push('/home');
                }
                
                
            } catch (error) {
                console.log(error)
                this.submitting = false;
            }

        },

        // Add this new method to calculate special necessities
        calculateSpecialNecessities() {
            const necessities = [];

            // B6 for nausea
            if (this.needsNauseaSupport()) {
                necessities.push('Script personalized to minimize GI side effects due to nausea sensitivity.');
            }

            // Glycine for muscle loss
            if (this.needsMuscleSupport()) {
                necessities.push('Script personalized to reduce muscle loss during weight loss.');
            }

            // B12 for energy
            if (this.needsEnergySupport()) {
                necessities.push('Script personalized due to patient-reported fatigue.');
            }

            // Multi-dose vial for flexibility
            if (this.needsFlexibleDosing()) {
                necessities.push('Multi-dose vial compounded for medically required dosing flexibility and patient control. Commercially available products rejecting personalized dosing.');
            }

            // Return comma-separated string of reasons
            return necessities.join(', ');
        },

        // Helper function to find question by its question property
        findQuestionByType(questionType) {
            return this.questions.find(q => q.question === questionType);
        },

        // Helper function to get answer by question type
        getAnswerByQuestionType(questionType) {
            const question = this.findQuestionByType(questionType);
            return question ? this.answers[question.id] : null;
        },

        // Helper function for nausea support
        needsNauseaSupport() {
            // Nausea sensitivity 1-10 (>7 is high sensitivity)
            const nauseaSensitivity = this.getAnswerByQuestionType('nausia_motion');
            const nauseaScore = nauseaSensitivity ? parseInt(nauseaSensitivity) : 0;

            // Would GI effects impact compliance (YES = needs support)
            const giImpactCompliance = this.getAnswerByQuestionType('nauseated_gi') === 'YES';

            // Important to minimize nausea (YES = needs support)
            const minimizeNausea = this.getAnswerByQuestionType('nauseated_experience') === 'YES';

            return nauseaScore > 7 || giImpactCompliance || minimizeNausea;
        },

        // Helper function for muscle support
        needsMuscleSupport() {
            // Previous muscle loss experience (YES = needs support)
            const previousMuscleLoss = this.getAnswerByQuestionType('experience_muscle_loss') === 'YES';

            // Important to conserve muscle (YES = needs support)
            const conserveMuscle = this.getAnswerByQuestionType('econserving_muscle_loss') === 'YES';

            return previousMuscleLoss || conserveMuscle;
        },

        // Helper function for energy support
        needsEnergySupport() {
            // Diagnosed with anemia (YES = needs support)
            const hasAnemia = this.getAnswerByQuestionType('diagnosed_anemia') === 'YES';

            // Issues with fatigue/low energy (YES = needs support)
            const hasFatigue = this.getAnswerByQuestionType('low_energy') === 'YES';

            // Low vitamin levels (YES = needs support)
            const lowVitamins = this.getAnswerByQuestionType('low_vitamin_levels') === 'YES';

            return hasAnemia || hasFatigue || lowVitamins;
        },

        // Helper function for flexible dosing
        needsFlexibleDosing() {
            // Want injection control (YES = needs flexibility)
            const wantInjectionControl = this.getAnswerByQuestionType('forcefully_injected') === 'YES';

            // Want dosage tailoring (YES = needs flexibility)  
            const wantDosageTailoring = this.getAnswerByQuestionType('personalized_levels') === 'YES';

            // Want dosing frequency tailoring (YES = needs flexibility)
            const wantFrequencyTailoring = this.getAnswerByQuestionType('doases_personalized_during') === 'YES';

            return wantInjectionControl || wantDosageTailoring || wantFrequencyTailoring;
        },

        // Main formatAnswers function
        formatAnswers() {
            const formattedAnswers = [];
            const images = [];
            const processedFollowUps = new Set(); // Track processed follow-up questions
            const additional_details = {
                allergies: '',
                current_meds: '',
                current_medical_condition: '',
                pregnancy: false
            };

            if (this.user?.gender === 'Female' && this.answers['0']) {
                additional_details.pregnancy = this.answers['0'] === 'Yes';
            }
            if (this.answers['21_1']) {
                if (this.answers['21_1'] === 'No - I affirm I have no known drug allergies') {
                    additional_details.allergies = this.answers['21_1'];
                } else if (this.answers['21_2']) {
                    additional_details.allergies = this.answers['21_2'];
                }
            }

            // Handle current medications
            if (this.answers['7_3']) {
                if (this.answers['7_3'] === "No - I affirm I'm not taking any medications") {
                    additional_details.current_meds = this.answers['7_3'];
                } else if (this.answers['7_4']) {
                    additional_details.current_meds = this.answers['7_4'];
                }
            }

            // Handle medical conditions
            if (this.answers['7_1']) {
                if (this.answers['7_1'] === 'No - I affirm I have no known medical conditions') {
                    additional_details.current_medical_condition = this.answers['7_1'];
                } else if (this.answers['7_2']) {
                    additional_details.current_medical_condition = this.answers['7_2'];
                }
            }
            const excludedQuestionIds = ['0', '21_1', '21_2', '7_3', '7_4', '7_1', '7_2'];
            // Process main questions
            this.questions.forEach(question => {
                if (excludedQuestionIds.includes(question.id) || !this.shouldShowQuestion(question)) {
                    return;
                }
                // Skip follow-up questions as they'll be handled separately
                if (question.isFollowUp) return;

                let answer = this.answers[question.id];
                if (answer === undefined) return;
                if (question.question_type === 'dose_optimization') return;

                // Handle dose radio more questions
                if (question.question_type === 'dose_radio_more') {
                    switch (this.answers[question.id]) {
                        case 'decrease':
                            answer = 'Decrease dose';
                            break;
                        case 'same':
                            answer = 'Stay at the same dose or equivalent dose';
                            break;
                        default:
                            answer = 'Increase the dose if a higher one is available, or continue with my current dose if its already at the maximum';
                    }
                }
                const {
                    important,
                    is_critical
                } = checkOptionProperties(question, answer);
                // Create formatted answer object
                const formattedAnswer = {
                    question: question.label,
                    answer: this.formatAnswerValue(answer),
                    type: this.determineAnswerType(question, answer),
                    description: question.description || '',
                    important: important || question.important || false,
                    is_critical: is_critical || question.is_critical || false,
                    label: question.label || '',
                    displayed_options: this.getDisplayedOptions(question)
                };

                // Handle image uploads separately
                if (formattedAnswer.type === 'image_upload') {
                    formattedAnswer.question = question.question;
                    images.push(formattedAnswer);
                } else {
                    formattedAnswers.push(formattedAnswer);
                }

                // Process follow-up questions if they exist
                if (question.followup_questions && this.multipleChoiceAnswers[question.id]) {
                    this.formatFollowupAnswers(
                        question,
                        this.multipleChoiceAnswers[question.id],
                        formattedAnswers,
                        processedFollowUps,
                    );
                }
            });

            return {
                answers: formattedAnswers,
                images: images,
                patientPreference: this.selectedDoses,
                additional_details: additional_details,
                special_necessities: this.calculateSpecialNecessities()
            };
        },

        // Helper function to format follow-up answers
        formatFollowupAnswers(parentQuestion, selectedOptions, formattedAnswers, processedFollowUps) {
            selectedOptions.forEach(option => {
                const followup = parentQuestion.followup_questions[option];
                // Skip if no followup or no answer
                if (!followup || !this.answers[followup.id]) return;
                // Skip if this follow-up has already been processed
                if (processedFollowUps.has(followup.id)) return;

                // Create follow-up answer object
                const followupAnswer = {
                    question: followup.label,
                    answer: this.formatAnswerValue(this.answers[followup.id]),
                    type: this.determineAnswerType(followup, this.answers[followup.id]),
                    description: followup.description || '',
                    label: followup.label || '',
                    important: followup.important,
                    is_critical: followup.is_critical,
                    metadata: `followup_to_${parentQuestion.id}_for_${option}`,
                    displayed_options: this.getDisplayedOptions(followup)
                };

                // Add to formatted answers and mark as processed
                formattedAnswers.push(followupAnswer);
                processedFollowUps.add(followup.id);
            });
        },

        // Helper function to format answer value
        formatAnswerValue(answer) {
            if (Array.isArray(answer)) {
                return answer.join('\n');
            }
            return String(answer);
        },

        // Helper function to determine answer type
        determineAnswerType(question, answer) {
            switch (question.question_type) {
                case 'single_option':
                case 'multiple_option':
                case 'text':
                case 'textarea':
                case 'string':
                    return 'string';
                case 'integer':
                    return 'number';
                case 'file':
                case 'image_upload':
                    return 'image_upload';
                default:
                    return typeof answer;
            }
        },

        // Helper function to get displayed options
        getDisplayedOptions(question) {
            if (question.options && Array.isArray(question.options)) {
                return question.options.map(option => option.title);
            }
            return [];
        },

        validateAllAnswers() {
            const requiredQuestions = this.questions.filter(q =>
                !q.is_optional && this.shouldShowQuestion(q)
            );

            return requiredQuestions.every(question => {
                const answer = this.answers[question.id];
                return !(answer === undefined || answer === '' ||
                    (Array.isArray(answer) && answer.length === 0));
            });
        },
        verifyAllFollowupsComplete() {
            for (const question of this.questions) {
                if (question.question_type === 'multiple_option' &&
                    question.followup_questions &&
                    !question.isFollowUp) {

                    const selectedAnswers = this.multipleChoiceAnswers[question.id] || []

                    if (selectedAnswers.length === 1 && selectedAnswers[0].toLowerCase().includes('none')) {
                        continue
                    }

                    const requiredCount = selectedAnswers.reduce((count, answer) => {
                        return count + (question.followup_questions[answer] ? 1 : 0)
                    }, 0)

                    const answeredCount = selectedAnswers.reduce((count, answer) => {
                        const followUp = question.followup_questions[answer]
                        return count + (followUp && this.answers[followUp.id] ? 1 : 0)
                    }, 0)

                    if (answeredCount < requiredCount) {
                        const nextIndex = this.findNextQuestion()
                        if (nextIndex !== null) {
                            this.currentQuestionIndex = nextIndex
                            this.currentAnswer = ''
                        }
                        return false
                    }
                }
            }
            return true
        },

        shouldShowQuestion(question) {
            // Skip questions 14 and 15 for bareMeds form type
            if (this.formType === 'bareMeds' && (question.id === '14' || question.id === '15')) {
                return false;
            }
            
            // Skip Florida Bill of Rights question if user is not in Florida
            if (question.question === 'florida_bill_of_rights' && this.userState && this.userState.toLowerCase() !== 'fl' && this.userState.toLowerCase() !== 'florida') {
                return false;
            }

            if (question.isFollowUp) {
                return true
            }

            const deps = this.dependencies.filter(d => d.question_id === question.id)
            if (!deps.length) return true

            return deps.every(dep => {
                const parentAnswer = this.answers[dep.dependent_on]
                if (!parentAnswer) return false

                if (Array.isArray(parentAnswer)) {
                    return parentAnswer.some(answer => dep.ask_if_val_in.includes(answer))
                }

                return dep.ask_if_val_in.includes(parentAnswer)
            })
        },

        validateAnswers() {
            const currentQuestion = this.currentQuestion;
            if (!currentQuestion) return true;

            if (currentQuestion.question_type === 'single_option') {
                const currentAnswer = this.getCurrentAnswer();
                const hasFollowup = this.dependencies.some(dep =>
                    dep.dependent_on === currentQuestion.id &&
                    dep.ask_if_val_in.includes(currentAnswer)
                );

                if (hasFollowup) {
                    return true;
                }
            }

            if (['text', 'textarea', 'image_upload'].includes(currentQuestion.question_type)) {
                return true;
            }

            if (currentQuestion.question_type === 'informational' && currentQuestion.has_next_button === false) {
                this.disqualifyMessage = currentQuestion.description || 'We cannot proceed with your application at this time.';
                this.showDisqualify = true;
                return false;
            }

            const relatedDependencies = this.dependencies.filter(dep =>
                dep.question_id === currentQuestion.id ||
                dep.dependent_on === currentQuestion.id
            );

            for (const dep of relatedDependencies) {
                const parentAnswer = this.answers[dep.dependent_on];
                if (!parentAnswer) continue;

                const answers = Array.isArray(parentAnswer) ? parentAnswer : [parentAnswer];
                if (!this.isFollowupDependency(dep)) {
                    const matchesDisqualifyingCondition = answers.some(answer =>
                        dep.ask_if_val_in.includes(answer)
                    );

                    if (matchesDisqualifyingCondition) {
                        const relatedQuestion = this.questions.find(q => q.id === dep.question_id);
                        if (relatedQuestion?.description) {
                            this.disqualifyMessage = relatedQuestion.description;
                            this.showDisqualify = true;
                            return false;
                        }
                    }
                }
            }

            return true;
        },

        isFollowupDependency(dependency) {
            const dependentQuestion = this.questions.find(q => q.id === dependency.question_id);
            const parentQuestion = this.questions.find(q => q.id === dependency.dependent_on);

            return dependentQuestion && (
                dependentQuestion.question_type === 'text' ||
                dependentQuestion.question_type === 'textarea' ||
                dependentQuestion.question_type === 'image_upload' ||
                (parentQuestion && parentQuestion.followup_questions)
            );
        },

        scrolltoTop() {
            window.scrollTo(0, 0);
        },

        // Additional crash recovery methods
        getSessionId() {
            // Generate or retrieve session ID for this browser session
            if (!window.sessionStorage.getItem('formSessionId')) {
                window.sessionStorage.setItem('formSessionId', 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9));
            }
            return window.sessionStorage.getItem('formSessionId');
        },

        cleanupOldBackups() {
            try {
                const backupPrefix = `${this.storageKey}_backup_`;
                const backupKeys = [];

                // Find all backup keys
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && key.startsWith(backupPrefix)) {
                        backupKeys.push(key);
                    }
                }

                // Sort by timestamp (newest first) and keep only last 3
                backupKeys.sort((a, b) => {
                    const timestampA = parseInt(a.split('_').pop());
                    const timestampB = parseInt(b.split('_').pop());
                    return timestampB - timestampA;
                });

                // Remove old backups (keep only 3 most recent)
                for (let i = 3; i < backupKeys.length; i++) {
                    localStorage.removeItem(backupKeys[i]);
                }
            } catch (error) {
                console.error('Error cleaning up old backups:', error);
            }
        },

        recoverFromBackups() {
            try {
                const backupPrefix = `${this.storageKey}_backup_`;
                const backupKeys = [];

                // Find all backup keys
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && key.startsWith(backupPrefix)) {
                        backupKeys.push(key);
                    }
                }

                // Sort by timestamp (newest first)
                backupKeys.sort((a, b) => {
                    const timestampA = parseInt(a.split('_').pop());
                    const timestampB = parseInt(b.split('_').pop());
                    return timestampB - timestampA;
                });

                // Try each backup until we find a valid one
                for (const key of backupKeys) {
                    try {
                        const backupData = localStorage.getItem(key);
                        if (backupData) {
                            const parsed = JSON.parse(backupData);
                            if (this.isValidProgressData(parsed)) {
                                console.log(`Recovered from backup: ${key}`);
                                return backupData;
                            }
                        }
                    } catch (e) {
                        console.warn(`Backup ${key} is corrupted`);
                    }
                }

                return null;
            } catch (error) {
                console.error('Error recovering from backups:', error);
                return null;
            }
        },

        detectPotentialCrash(progressData) {
            // Detect if this recovery might be from a crash
            if (!progressData.crashRecovery) return false;

            const now = Date.now();
            const lastActive = progressData.crashRecovery.lastActiveTimestamp;
            const timeSinceLastActive = now - lastActive;

            // If more than 5 minutes since last activity and form wasn't completed
            return timeSinceLastActive > 300000 && !progressData.crashRecovery.isFormComplete;
        },

        showCrashRecoveryDialog(progressData) {
            // This could be enhanced to show a user-friendly dialog
            console.log('Crash recovery options available:', {
                questionsAnswered: progressData.crashRecovery.totalAnswersCount,
                currentQuestion: progressData.currentQuestionIndex + 1,
                lastSaved: new Date(progressData.savedAt).toLocaleString()
            });
        },

        showRecoveryNotification(progressData) {
            // Show a brief notification that progress was recovered
            console.log(`✅ Progress recovered from ${new Date(progressData.savedAt).toLocaleString()}`);

            // You could implement a toast notification here like:
            //this.$toast.success(`Welcome back! Your progress has been restored from ${new Date(progressData.savedAt).toLocaleString()}`);
        },

        saveMinimalProgress() {
            // Fallback save with only essential data if full save fails
            try {
                const minimalData = {
                    currentQuestionIndex: this.currentQuestionIndex,
                    answers: this.answers,
                    savedAt: new Date().toISOString(),
                    version: '1.0-minimal'
                };

                localStorage.setItem(this.storageKey + '_minimal', JSON.stringify(minimalData));
                console.log('Minimal progress saved as fallback');
            } catch (error) {
                console.error('Even minimal save failed:', error);
            }
        }
    }
}
</script>

<style scoped>
.selected {
    background-color: #f0f0f0;
}

.file-upload-container {
    margin-bottom: 1rem;
}

.file-preview {
    margin-top: 1rem;
}

.image-preview {
    max-width: 200px;
    max-height: 200px;
    object-fit: contain;
}

.file-name {
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: #666;
}

.next-button-enabled {
    opacity: 1;
    cursor: pointer;
}

.next-button-enabled:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.info-message {
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 4px;
    margin-bottom: 1rem;
}

.checkbox-field-15 {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
}

.checkbox-11 {
    margin-right: 0.5rem;
}

.acceptbutton {
    background-color: var(--light-green) !important;
    border: none;
    color: #fff
}

.rejectconbutton {
    background-color: transparent !important;
    height: 20px;
    border: none;
    text-align: center;
    justify-content: center;
}

.rejectconbutton .text-block-545 {
    font-size: 12px !important;
}

.dose-sched-box {
    width: 32%;
    padding: 10px 2px;
}

.select-field-10 {
    width: 72%;
}

@media (max-width: 768px) {
    .setsizeonphone {
        max-width: 100%;
        padding-right: 10px;
        padding-left: 10px;
    }
}

@media screen and (max-width: 479px) {
    .dose-sched-box.solo {
        width: 100%;
    }
}


.image-uploader {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
}

.upload-box {
    position: relative;
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 15px;
}

.upload-box:hover {
    border-color: #666;
}

.drag-over {
    border-color: #2196F3;
    background-color: rgba(33, 150, 243, 0.1);
}

.file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
}

.upload-content {
    padding: 20px;
}

.upload-icon {
    font-size: 48px;
    margin-bottom: 10px;
}

.upload-prompt p {
    margin: 10px 0;
    font-size: 16px;
    color: #666;
}

.file-size-info {
    font-size: 14px;
    color: #999;
    margin-top: 5px;
}

.file-info {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin: 5px 0;
}

.upload-info {
    font-size: 14px;
    color: #999;
}

.preview {
    margin: 10px 0;
}

.preview img {
    max-width: 100%;
    max-height: 300px;
    border-radius: 4px;
    margin-bottom: 10px;
}

.loading {
    padding: 20px;
    color: #666;
}

.error-message {
    color: #f44336;
    margin-top: 10px;
    font-size: 14px;
    padding: 10px;
    background-color: #ffebee;
    border-radius: 4px;
    border: 1px solid #ffcdd2;
}

.error-action {
    margin-top: 5px;
    font-weight: 500;
}

.error-state {
    background-color: #f44336 !important;
    border-color: #d32f2f !important;
}

.error-state:hover {
    background-color: #d32f2f !important;
}

/* Upload Progress Bar Styles */
.upload-progress-container {
    margin-bottom: 15px;
}

.upload-progress-bar {
    width: 100%;
    height: 8px;
    background-color: #f0f0f0;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;
}

.upload-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #2196F3, #21CBF3);
    transition: width 0.3s ease;
    border-radius: 4px;
}

.upload-progress-text {
    text-align: center;
    font-size: 14px;
    color: #666;
    font-weight: 500;
}
</style>

